module.exports = __webpack_public_path__ + "img/logo-animasjon-loop.688e7b0b.gif";